import React from "react";

const ICONS = {
  check: (
    <>
      <path
        d="M5 12.5 9.2 16.7 19 7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </>
  ),
  envelope: (
    <>
      <path
        d="M4 7.5h16v9H4z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="m4.8 8.2 7.2 5.4 7.2-5.4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </>
  ),
  globe: (
    <>
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M3 12h18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
      <path
        d="M12 3c2.6 2.5 4.2 5.8 4.2 9S14.6 18.5 12 21c-2.6-2.5-4.2-5.8-4.2-9S9.4 5.5 12 3Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </>
  ),
  help: (
    <>
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M9.6 9.4a2.7 2.7 0 1 1 4.9 1.5c-.6.8-1.6 1.2-2.1 1.9-.3.4-.4.8-.4 1.4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <circle cx="12" cy="17.2" r="1" fill="currentColor" />
    </>
  ),
  play: (
    <path
      d="m8 7.2 9 4.8-9 4.8V7.2Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1"
    />
  ),
  user: (
    <>
      <circle
        cx="12"
        cy="8.5"
        r="3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M6.2 18c.5-2.8 2.8-4.5 5.8-4.5s5.3 1.7 5.8 4.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
    </>
  ),
  whatsapp: (
    <>
      <path
        d="M12 3a8.8 8.8 0 0 0-7.6 13.2L3.3 20.7l4.7-1.1A8.9 8.9 0 1 0 12 3Z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="M9.2 8.8c.2-.4.4-.4.6-.4h.4c.2 0 .4.1.5.4l.5 1.4c.1.2 0 .4-.1.6l-.4.5c-.1.2-.1.3 0 .5.3.5 1 1.2 1.7 1.7.3.2.4.1.6 0l.6-.8c.2-.2.4-.3.6-.2l1.4.6c.2.1.3.3.3.5-.1.7-.4 1.4-.9 1.8-.4.3-1 .4-1.7.2-1.1-.3-2.2-1-3.6-2.3-1.4-1.3-2.1-2.6-2.3-3.6-.2-.7-.1-1.3.2-1.7Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </>
  ),
};

export const Icon = ({
  className = "",
  name,
  title,
  viewBox = "0 0 24 24",
  ...props
}) => {
  const icon = ICONS[name];

  if (!icon) {
    return null;
  }

  return (
    <svg
      className={["app-icon", className].filter(Boolean).join(" ")}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      {...(title ? { "aria-label": title, role: "img" } : { "aria-hidden": "true" })}
      {...props}
    >
      {icon}
    </svg>
  );
};

export default Icon;
